import { useAsyncData, useNuxtApp, useRoute } from '#imports'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'
import { useUtmSource } from '~/scopes/product-core/composables/useUtmSource/useUtmSource'

export function useFetchProduct(route = useRoute()) {
  const nuxtApp = useNuxtApp()

  // The product id should be passed in the URL as a param.
  // But for webviews, the product id is passed in the query string.
  const productId = useUrlParams(route).productId || route.query.productId
  const utmSource = useUtmSource(route)
  const $httpFetch = useHttpFetch()
  const { isMasterPPUrl } = useMasterPP(route)

  return useAsyncData(
    () => `pp-product-${productId}`,
    async () =>
      await $httpFetch('/product-page/products/:productId', {
        pathParams: { productId },
        query: {
          partnerId: utmSource,
        },
      }),

    {
      default: () => undefined,
      transform: (p: GetProductResponse) => {
        if (isMasterPPUrl.value) {
          return {
            ...p,
            titles: {
              ...p.titles,
              raw: p.titles.default,
            },
          }
        }

        return p
      },
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
